import apiService from 'src/shared/config/apiService';
import { User } from 'src/shared/types/user';
import handleAxiosError from 'src/shared/utils/handleAxiosError';
import { getBrowserTimezone } from 'src/shared/utils/timezone';

import normalizeUserData from '../utils/normalizeUserData';

export const getUser = async () => {
  try {
    // Lets the backend record the timezone of users who never set one.
    const response = await apiService.get<User>('/me', {
      params: { timezone: getBrowserTimezone() }
    });

    const normalized = normalizeUserData(response.data);

    return normalized;
  } catch (error) {
    throw handleAxiosError(error);
  }
};
